/** Ricerca dei piatti: tre lettere e in cima esce quello giusto.

Regole, dalla più importante: chi inizia con quello che hai scritto va prima, poi chi inizia con quelle
lettere in una parola successiva (una «marg» trova «Pizza margherita»), poi chi le contiene, infine la
categoria. Accenti e maiuscole non contano: «ragu» trova «Ragù».
*/
const pulisci = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const punteggio = (piatto, q) => {
  const nome = pulisci(piatto.name);
  if (nome === q) return 0;
  if (nome.startsWith(q)) return 1;
  if (nome.split(" ").some((w) => w.startsWith(q))) return 2;
  if (nome.includes(q)) return 3;
  if (pulisci(piatto.category).startsWith(q)) return 4;
  if (pulisci(piatto.category).includes(q) || pulisci(piatto.department).includes(q)) return 5;
  return 99;
};

export const cercaPiatti = (menu, testo) => {
  const q = pulisci(testo);
  if (!q) return [];
  return menu
    .map((m) => ({ m, s: punteggio(m, q) }))
    .filter((x) => x.s < 99)
    .sort((a, b) => a.s - b.s || a.m.name.length - b.m.name.length || a.m.name.localeCompare(b.m.name))
    .map((x) => x.m);
};
